import { render, staticRenderFns } from "./record-history.vue?vue&type=template&id=2ad111e8"
import script from "./record-history.vue?vue&type=script&lang=ts"
export * from "./record-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports